document.addEventListener("DOMContentLoaded", function () {

    const website = window.location.href;
    const websiteSwe = "hakisafety.se";
    const websiteEng = "hakisafety.com";
    const testsite = "haki.test.litium.site/hakisafety";
    

    if (website.includes(websiteSwe) || website.includes(websiteEng) || website.includes(testsite) || website.includes('hakisafety')) {

        // Step 1
        const navbarLinks = document.querySelectorAll('.navbar__menu-links > .navbar__item > .navbar__link');
        navbarLinks.forEach(item => {
            item.classList.add('top-level-links');
        });

        // Step 2
        const elementsToRemoveClass = document.querySelectorAll('.navbar__menu-links > .navbar__item > .navbar__menu > .navbar__menu-links > .navbar__item > .navbar__link');
        elementsToRemoveClass.forEach(element => {
            element.classList.remove('top-level-links');
        });

        // Step 3
        const remainingNavbarLinks = document.querySelectorAll('.navbar__menu-links > .navbar__item > .navbar__link.top-level-links');
        remainingNavbarLinks.forEach(item => {
            item.href = 'javascript:void(0)';
        });
    } 
    
});